import { createRouter, createWebHistory } from "vue-router";

const Home = () => import("@/pages/index");
const Error = () => import("@/pages/error");
// const AboutUs = () => import("@/pages/about");

const TermsOfService = () => import("@/pages/terms-of-service");
const PrivacyPolicy = () => import("@/pages/privacy-policy");
//
// const Home = () => import("@/pages/app/home");
// const Transactions = () => import("@/pages/app/transactions");
// const Settings = () => import("@/pages/app/settings");

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/:patchmatch(.*)*",
      name: "error",
      component: Error,
      meta: {
        layout: "onboarding",
      },
    },
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        guest: true,
      },
    },
    // {
    //   path: "/about-us",
    //   name: "about-us",
    //   component: AboutUs,
    //   meta: {
    //     guest: true,
    //   },
    // },
    {
      path: "/terms-of-service",
      name: "terms-of-service",
      component: TermsOfService,
      meta: {
        guest: true,
      },
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: PrivacyPolicy,
      meta: {
        guest: true,
      },
    },
    // {
    //   path: "/home",
    //   name: "home.index",
    //   component: Home,
    //   meta: {
    //     requiresAuth: true,
    //     requiresAccountVerification: true,
    //     layout: "app",
    //   },
    // },
    // {
    //   path: "/transactions",
    //   name: "transactions.index",
    //   component: Transactions,
    //   meta: {
    //     requiresAuth: true,
    //     requiresAccountVerification: true,
    //     layout: "app",
    //   },
    // },
    // {
    //   path: "/settings",
    //   name: "settings.index",
    //   component: Settings,
    //   meta: {
    //     requiresAuth: true,
    //     requiresAccountVerification: true,
    //     layout: "app",
    //   },
    // },
  ],
});

export default router;
